// @flow
import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment-timezone';
import {
  Modal, Select, Row, Col, DatePicker, Input,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import { SpH5, SpButton, SpError } from 'components/DesignKit';
import notify from 'components/NavIcons/notifiy';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  subscriptionDetails: Object,
  selectedAccount: Function,
};

const { Option } = Select;

const UpdateSubscription = (props: Props) => {
  const {
    visible,
    close,
    submit,
    subscriptionDetails,
    selectedAccount,
  } = props;

  const [, forceUpdate] = useState();
  const dateFormat = 'MMM DD, YYYY';
  const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
  const [dop, setDop] = useState('');
  const [disableDate, setDisableDate] = useState('');
  const [planApiDate, setPlanApiDate] = useState('');

  useEffect(() => {
    if (subscriptionDetails && subscriptionDetails.gid) {
      const displayFormat = moment(subscriptionDetails.nextPaymentDate).format(dateFormat);
      const displayFormat1 = moment().utc(new Date()).tz(selectedAccount.timezone).startOf('day')
        .format(dateFormat);
      setDisableDate(displayFormat);
      setDop(displayFormat1);
    } else {
      const displayFormat = moment().utc().tz(selectedAccount.timezone).startOf('day')
        .format(dateFormat);
      const displayFormat1 = moment().utc(new Date()).tz(selectedAccount.timezone).startOf('day')
        .format(dateFormat);
      if (selectedAccount && selectedAccount.timezone) {
        setDisableDate(displayFormat);
        setDop(displayFormat1);
      }
    }
  }, [subscriptionDetails]);

  const onDateChange = (date, dateString) => {
    setDop(dateString);
    // eslint-disable-next-line
      const Date = moment(date._d).format(MOMENT_FORMAT);
    const selectedDate = moment.tz(Date, selectedAccount.timezone);
    const utcDate = selectedDate.utc().format(MOMENT_FORMAT);
    setPlanApiDate(utcDate);
  };

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      frequency: {
        message: 'Billing period should not be more than 365 days',
        // eslint-disable-next-line radix
        rule: (val) => parseInt(val) <= 365,
      },
    },
  }));

  // eslint-disable-next-line consistent-return
  const deleteSelectedSubscription = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return false;
    }
    const payload = {
      nextPaymentDate: planApiDate,
    };
    submit(payload);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      title="Update Subscription Details"
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedSubscription} type="primary">Update Subscription</SpButton>,
      ]}
    >
      <div className="px-4">
        <div className="mb-3">
          <Row type="flex" justify="start" align="middle">
            <Col span={9}>
              <span>Plan Name</span>
            </Col>
            <Col span={15}>
              <SpH5>{subscriptionDetails?.plan2?.name || <>&#8211;</>}</SpH5>
            </Col>
          </Row>
        </div>
        <div className="mb-3">
          <Row type="flex" justify="start" align="middle">
            <Col span={9}>
              <span>Plan Descriptions</span>
            </Col>
            <Col span={15}>
              <SpH5>{subscriptionDetails?.plan2?.description || <>&#8211;</>}</SpH5>
            </Col>
          </Row>
        </div>
        <div className="mb-3">
          <Row type="flex" justify="start" align="middle">
            <Col span={9}>
              <span>No. Of Billing Cycle</span>
            </Col>
            <Col span={15}>
              <SpH5>{subscriptionDetails?.plan2TotalPayments || <>&#8211;</>}</SpH5>
            </Col>
          </Row>
        </div>
        <div className="mb-3">
          <Row type="flex" justify="start" align="middle">
            <Col span={9}>
              <span>Remaining Billing Cycle</span>
            </Col>
            <Col span={15}>
              <SpH5>{subscriptionDetails?.remainingBillingCycles || <>&#8211;</>}</SpH5>
            </Col>
          </Row>
        </div>
        <div className="mb-3">
          <Row type="flex" justify="start" align="middle">
            <Col span={9}>
              <span>Next Payment Due On</span>
            </Col>
            <Col span={15}>
              <SpH5>
                {subscriptionDetails.nextPaymentDate
                  ? (
                    moment
                      .utc(subscriptionDetails.nextPaymentDate)
                      .tz(selectedAccount.timezone)
                      .format('MMM DD, YYYY')
                  )
                  : <>&#8211;</>}
              </SpH5>
            </Col>
          </Row>
        </div>
        <div>
          <label htmlFor=""><SpH5>Update Next Payment Date</SpH5></label>
          <div>
            <DatePicker
              value={moment(dop)}
              format={dateFormat}
              allowClear={false}
              onChange={onDateChange}
              disabledDate={current => ((current && current.isAfter(moment(disableDate))) || (current && current.isBefore(moment(dop))))}
            />
            <SpError>
              {simpleValidator.current.message('Next Payment Date', planApiDate, 'required')}
            </SpError>
          </div>
        </div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default UpdateSubscription;
